import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_FETCH } from '../../services';
import { ENDPOINTS } from '../../constants/endpoints';

// ========================================
// TYPES
// ========================================
export interface Supervisor {
    workdayId: string;
    firstName: string;
    lastName: string;
}

interface SupervisorState {
    supervisors: Supervisor[];
    loading: boolean;
    error: string | null;
}

const initialState: SupervisorState = {
    supervisors: [],
    loading: false,
    error: null,
};

// ========================================
// ASYNC THUNKS
// ========================================
/**
 * Fetch all supervisors for a site
 * Uses: GET /api/shift/getSupervisors/{siteCd}
 */
export const fetchSupervisors = createAsyncThunk(
    'supervisors/fetchSupervisors',
    async (siteCd: string, { rejectWithValue }) => {
        try {
            const response = await API_FETCH(`${ENDPOINTS.GET_SUPERVISORS}/${siteCd}`);
            console.log('✅ Supervisors API Response:', response);
            return response as Supervisor[];
        } catch (error: any) {
            console.error('❌ Supervisors API Error:', error);
            return rejectWithValue(error?.message || 'Failed to fetch supervisors');
        }
    }
);

// ========================================
// SLICE
// ========================================
const supervisorSlice = createSlice({
    name: 'supervisors',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSupervisors.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSupervisors.fulfilled, (state, action) => {
                state.loading = false;
                state.supervisors = action.payload;
            })
            .addCase(fetchSupervisors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { clearError } = supervisorSlice.actions;
export default supervisorSlice.reducer;